import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const Link = ({ label, highlighted, ...rest }) => (
  <li
    className={classNames('dropdown__item', {
      'dropdown__item--highlighted': highlighted,
    })}
    {...rest}>
    <div className="dropdown__item__content">{label}</div>
  </li>
);

Link.propTypes = {
  label: PropTypes.object.isRequired,
  highlighted: PropTypes.bool.isRequired,
};
